// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tAk1xT4nT1UOicvFRPgz{padding-top:16px}.WiQ0VcymcXYnSs6GNdhz{padding-top:40px}.IZxQNO9K0AOX51wMH9qz{justify-content:center;width:100%;margin-bottom:16px;display:flex}.IZxQNO9K0AOX51wMH9qz .Yx8oVwAeM102tK70btlr{background:var(--background-neutral-default);aspect-ratio:1;border-radius:50%;justify-content:center;align-items:center;width:28px;display:flex}.QGqSte6HRacHZDmudV8p{padding-top:32px;padding-bottom:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"desc": `tAk1xT4nT1UOicvFRPgz`,
	"content": `WiQ0VcymcXYnSs6GNdhz`,
	"arrowWrap": `IZxQNO9K0AOX51wMH9qz`,
	"arrow": `Yx8oVwAeM102tK70btlr`,
	"actions": `QGqSte6HRacHZDmudV8p`
};
export default ___CSS_LOADER_EXPORT___;
